module.exports = __webpack_public_path__ + "img/comments_marker.b79507d0.svg";